export interface WorkItem {
  id: number;
  title: string;
  author: string;
  category: string;
  status: "连载中" | "已完结" | "休载";
  episodes: number;
  followers: string;
  rating: number;
  tags: string[];
  synopsis: string;
  cover: string;
}

export const categoryList = [
  "全部",
  "热血",
  "悬疑",
  "恋爱",
  "科幻",
  "奇幻",
  "校园",
  "治愈",
];

export const works: WorkItem[] = [
  {
    id: 1,
    title: "星轨漂流记",
    author: "林深见鹿",
    category: "科幻",
    status: "连载中",
    episodes: 126,
    followers: "8.6万",
    rating: 9.2,
    tags: ["太空歌剧", "群像", "高燃"],
    synopsis: "在一艘驶向未知星域的殖民飞船上，年轻领航员阿澈被卷入一场跨越光年的阴谋。每一条星轨都藏着答案，而同好们在漫圈里一起推理真相、绘制星图。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20young%20navigator%20on%20a%20spacecraft%20bridge%20watching%20a%20nebula%20through%20a%20large%20window%2C%20warm%20coral%20orange%20and%20teal%20color%20palette%2C%20cinematic%20soft%20light%2C%20clean%20bold%20comic%20cover%20composition%2C%20manga%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-01&orientation=portrait",
  },
  {
    id: 2,
    title: "暗巷侦探社",
    author: "墨鱼丸",
    category: "悬疑",
    status: "已完结",
    episodes: 88,
    followers: "12.3万",
    rating: 9.5,
    tags: ["本格推理", "都市", "反转"],
    synopsis: "午夜营业的侦探社，专门接手警方束手无策的怪案。当一切线索指向十年前那场大火，社员们才发现自己也在故事之中。每案一推，漫圈全程高能。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20noir%20detective%20agency%20office%20at%20night%20with%20a%20fedora%20detective%20examining%20clues%20under%20a%20desk%20lamp%2C%20teal%20and%20warm%20amber%20palette%2C%20moody%20dramatic%20lighting%2C%20manga%20cover%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-02&orientation=portrait",
  },
  {
    id: 3,
    title: "晴空守望者",
    author: "苏打气泡",
    category: "恋爱",
    status: "连载中",
    episodes: 64,
    followers: "6.1万",
    rating: 8.8,
    tags: ["纯爱", "青春", "治愈"],
    synopsis: "天台上的约定，教室里的心跳。少年与少女在毕业季来临前，用一整年交换彼此的秘密。细腻到每根发丝都在发光，漫圈里满是写满心事的同好。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20boy%20and%20girl%20on%20a%20school%20rooftop%20under%20a%20bright%20blue%20sky%20with%20soft%20sunlight%2C%20warm%20cream%20and%20coral%20pastel%20palette%2C%20romantic%20gentle%20atmosphere%2C%20shoujo%20manga%20cover%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-03&orientation=portrait",
  },
  {
    id: 4,
    title: "苍蓝王座",
    author: "北冥有鱼",
    category: "奇幻",
    status: "连载中",
    episodes: 210,
    followers: "20.8万",
    rating: 9.4,
    tags: ["架空世界", "史诗", "权谋"],
    synopsis: "四国大陆、七位王储，一顶苍蓝王座牵动整个时代。元素之力觉醒的少年从边陲崛起，卷入王权的旋涡。世界观设定庞大，漫圈专门开设设定考据楼。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20young%20king%20in%20armor%20standing%20before%20a%20glowing%20sapphire%20throne%20in%20a%20grand%20fantasy%20hall%2C%20deep%20blue%20and%20warm%20gold%20palette%20with%20teal%20accents%2C%20epic%20manga%20cover%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-04&orientation=portrait",
  },
  {
    id: 5,
    title: "热血篮球部",
    author: "咸鱼翻身",
    category: "热血",
    status: "连载中",
    episodes: 152,
    followers: "9.9万",
    rating: 9.0,
    tags: ["体育", "励志", "团队"],
    synopsis: "一支垫底高中的篮球队，一群不服输的少年。最后一节的最后一攻，汗水与羁绊在此刻沸腾。每一场比赛都让漫圈的同好喊到破音。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20basketball%20team%20in%20a%20gymnasium%20jumping%20for%20a%20dunk%20with%20warm%20spotlights%20and%20flying%20sweat%2C%20coral%20orange%20and%20amber%20palette%2C%20dynamic%20energetic%20sports%20manga%20cover%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-05&orientation=portrait",
  },
  {
    id: 6,
    title: "深夜食堂奇谭",
    author: "喵掌柜",
    category: "治愈",
    status: "已完结",
    episodes: 42,
    followers: "5.4万",
    rating: 9.1,
    tags: ["美食", "温情", "单元剧"],
    synopsis: "只在午夜营业的小食堂，每道菜都藏着一个客人的故事。暖黄色的灯光下，孤独的灵魂被一口热汤治愈。漫圈同好最爱交流各自的人生小确幸。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20cozy%20midnight%20diner%20counter%20with%20steaming%20bowls%20and%20warm%20hanging%20lamps%2C%20warm%20cream%20amber%20and%20coral%20palette%2C%20gentle%20healing%20manga%20cover%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-06&orientation=portrait",
  },
  {
    id: 7,
    title: "逆光少年",
    author: "纸飞机",
    category: "校园",
    status: "连载中",
    episodes: 58,
    followers: "4.7万",
    rating: 8.7,
    tags: ["成长", "友情", "青春"],
    synopsis: "被所有人称作'问题学生'的少年，在转学的第一天遇见了执拗的同桌。逆光之下的青春，原来也有被温柔以待的可能。漫圈里满是共鸣的留言。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20teenage%20boy%20walking%20through%20a%20sunlit%20school%20corridor%20with%20backlight%20glare%2C%20warm%20cream%20and%20soft%20teal%20palette%2C%20youthful%20coming%20of%20age%20manga%20cover%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-07&orientation=portrait",
  },
  {
    id: 8,
    title: "永夜回响",
    author: "拾荒者",
    category: "奇幻",
    status: "休载",
    episodes: 73,
    followers: "7.2万",
    rating: 9.0,
    tags: ["暗黑童话", "悬疑", "设定党"],
    synopsis: "永夜降临后，世界只剩下会说话的回响。少女带着一只会唱歌的布偶，去寻找第一束光。暗黑中带着一丝温度，漫圈的考据党们停更也不散。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20girl%20with%20a%20fabric%20doll%20walking%20through%20a%20dark%20starlit%20night%20forest%20with%20a%20single%20beam%20of%20light%2C%20deep%20teal%20and%20warm%20amber%20palette%2C%20dark%20fairy%20tale%20manga%20cover%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-08&orientation=portrait",
  },
  {
    id: 9,
    title: "云端旅行社",
    author: "棉被君",
    category: "治愈",
    status: "连载中",
    episodes: 31,
    followers: "3.9万",
    rating: 8.9,
    tags: ["旅行", "单元剧", "温暖"],
    synopsis: "能带你去云端的旅行社，老板是一只会泡茶的猫咪。每段旅程都像一场温柔的梦，醒来却舍不得忘记。适合睡前打开，漫圈同好一起云旅行。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20cat%20in%20a%20travel%20agency%20office%20with%20floating%20clouds%20out%20the%20window%20and%20teacups%2C%20soft%20cream%20teal%20and%20warm%20coral%20palette%2C%20dreamy%20whimsical%20manga%20cover%20style%2C%20high%20detail&width=600&height=800&seq=work-cover-09&orientation=portrait",
  },
];